import { Component, inject, input } from '@angular/core';
import { DictionaryService } from '../../../../services/dictionary.service';

@Component({
  selector: 'app-horizonal-bar',
  imports: [],
  templateUrl: './horizonal-bar.component.html',
  styleUrl: './horizonal-bar.component.scss',
})
export class HorizonalBarComponent {
  dictionaryService = inject(DictionaryService);
  title = input<string>('');
  shifted = input.required<number>();
  available = input.required<number>();
  total = input.required<number>();

  get annualWrapper(): number {
    return (this.total() / (this.total() + this.shifted())) * 100;
  }

  get annualValue(): number {
    return this.total() > 0
      ? this.available() > this.total()
        ? 100
        : (this.available() / this.total()) * 100
      : 0;
  }

  get leaveBalance(): string {
    return this.available() > this.total()
      ? `${this.total()} / ${this.total()}`
      : `${this.available() - this.shifted()} / ${this.total()}`;
  }

  get shiftedWrapper(): number {
    return this.available() > this.total()
      ? ((this.available() - this.total()) / this.available()) * 100
      : 0;
  }

  get shiftedValue(): number {
    return this.available() > this.total()
      ? this.available() - this.total()
      : 0;
  }
}
